import { getRecipientInfosAndAttachmentWell } from '../utils/getRecipientInfosAndAttachmentWell';
import { onMailTipRetrieved } from 'owa-mail-tips';
import { lazyExpandGroupsAndSmallDLs } from 'owa-recipient-permission-checker';
import { orchestrator } from 'satcheljs';

orchestrator(onMailTipRetrieved, async actionMessage => {
    const [recipientInfos, attachmentWell] = await getRecipientInfosAndAttachmentWell();

    if (recipientInfos && attachmentWell) {
        lazyExpandGroupsAndSmallDLs.importAndExecute(
            attachmentWell.sharingLinkIds,
            recipientInfos,
            attachmentWell.composeId,
            true /* isCalendar */
        );
    }
});
